<template>
    <div class="parametric-checkbox">
        <div class="parametric-checkbox__label">{{ label }}</div>
        <ul class="parametric-checkbox__items">
            <li v-for="option in options"
                :key="option.value"
                :class="['parametric-checkbox__item', `parametric-checkbox__item-${viewType}`, {'is-disabled': option.disabled}]">
                <input :id="`${name}[${option.id}]`"
                       type="checkbox"
                       :name="`${name}[${option.id}]`"
                       :checked="option.checked"
                       :disabled="option.disabled"
                       :value="option.value"
                       @change="selectItem" />
                <label class="parametric-checkbox__item-label"
                       :for="`${name}[${option.id}]`">
                    <span class="parametric-checkbox__item-icon"></span>
                    {{ option.title }}
                </label>
            </li>
        </ul>
    </div>
</template>

<script>
/**
 * Компонент для списка чекбоксов
 */
export default {
    name: 'ParametricCheckbox',

    props: {
        /**
         * Общее имя чекбокса
         */
        name    : String,
        /**
         * Лабел/описание чекбоксов
         */
        label   : String,
        /**
         * Выводимые чекбоксы
         */
        options : Array,
        /**
         * Тип чекбоксов (модификатор)
         */
        viewType: String
    },

    methods: {
        /**
         * Событие при изменении чекбокса
         */
        selectItem() {
            this.$nextTick(() => {
                this.$emit('onChange');
            });
        }
    }
};
</script>

<style lang="scss">
@import "ParametricCheckbox";
</style>
